module.exports = __webpack_public_path__ + "img/pickup-done.5e1391c2.svg";